import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const ContentView = (props) => {
  const careviewItem = props.careviewItem;

  const questionTitle = careviewItem.questionData.questionTitle;

  return (
    <Stack>
      <Box>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '18px',
            }}
          >
            <Translate
              expression='loomLead.LoomLeadDetail.CareviewSettings.Types.FiveStar.Question'
            />
          </Typography>
        </Box>
        <Box>
          <Typography
            sx={{
              fontSize: '16px',
            }}
          >
            {questionTitle}
          </Typography>
        </Box>
      </Box>
    </Stack>
  );
};

ContentView.propTypes = {
  careviewItem: PropTypes.object.isRequired,
};
export default React.memo(ContentView);
